window.GMap ?= {}

GMap.View = require './views/g_map'

GMap.init = ({dynamicMaps, multipleLocations, staticMaps}, done) ->
  return done() unless dynamicMaps?

  $ ->
    if staticMaps?.shouldLazyLoadControls
      $(window).load ->
        for map in dynamicMaps
          view = new GMap.View _.extend(map, {staticMaps})
        done()
    else
      for map in dynamicMaps
        view = new GMap.View map
      done()

module.exports = GMap
